import Home from '../../pages/default/Home'
import DoctorList from '../../components/doctors/DoctorList'
import PhysioList from "../../components/physios/PhysioList";
import PatientList from '../../components/patients/PatientList'
import PatientView from '../../components/patients/PatientView'

import PatientForm from '../../components/patients/PatientForm'
import patientRouter from './patient/patient'
import studyRouter from './study/study'
import surveyRouter from './survey/survey'
import ScoreView from "../../components/patients/score/ScoreView";
import DoctorForm from "../../components/doctors/DoctorForm";
import PhysioForm from "../../components/physios/PhysioForm";
import StudyList from "../../components/studies/StudyList.vue";
import StudyForm from "../../components/studies/StudyForm.vue";
import StudyView from "../../components/studies/StudyView.vue";
import SurveyList from "../../components/surveys/SurveyList.vue";
import SurveyForm from "../../components/surveys/SurveyForm.vue";
import SurveyView from "../../components/surveys/SurveyView.vue";
import PollList from "../../components/polls/PollList.vue";
import PollForm from "../../components/polls/PollForm.vue";
import PollView from "../../components/polls/PollView.vue";
import PatientQuickAdd from "../../components/patients/PatientQuickAdd.vue";

export default {
    path: '/',
    component: Home,
    meta: {
        auth: {roles: ['USER', 'ADMIN'], redirect: {name: 'login'}, forbiddenRedirect: '/403'}
    },
    children: [
        {
            path: '',
            name: 'home',
            component: PatientList
        },
        {
            path: 'patient/view/:patient_id/medical_cases/view/:medical_case_id/treatment/:treatment_id/follow_up/:follow_up_id/:concern',
            name: 'patient.openFollowUp',
            component: ScoreView,
            props: { locked: false }
        },
        {
            path: '/patient/view/:id',
            component: PatientView,
            children: patientRouter
        },
        {
            path: '/patient/add',
            name: 'patient.add',
            component: PatientForm,
            props: { locked: false }
        },
        {
            path: '/patient/quick-add',
            name: 'patient.quickAdd',
            component: PatientQuickAdd,
        },
        {
            path: 'doctors',
            name: 'doctors',
            component: DoctorList
        },
        {
            path: '/doctor/add',
            name: 'doctor.add',
            component: DoctorForm
        },
        {
            path: '/doctor/edit/:id',
            name: 'doctor.edit',
            component: DoctorForm
        },
        {
            path: 'physios',
            name: 'physios',
            component: PhysioList
        },
        {
            path: '/physio/add',
            name: 'physio.add',
            component: PhysioForm
        },
        {
            path: '/physio/edit/:id',
            name: 'physio.edit',
            component: PhysioForm
        },
        {
            path: 'studies',
            name: 'studies',
            component: StudyList
        },
        {
            path: '/study/add',
            name: 'study.add',
            component: StudyForm
        },
        {
            path: '/study/view/:id',
            component: StudyView,
            children: studyRouter
        },
        {
            path: '/surveys',
            name: 'surveys',
            component: SurveyList
        },
        {
            path: '/survey/add',
            name: 'survey.add',
            component: SurveyForm
        },
        {
            path: '/survey/view/:id',
            component: SurveyView,
            children: surveyRouter,
        },
        {
            path: '/polls',
            name: 'polls',
            component: PollList
        },
        {
            path: '/poll/add',
            name: 'poll.add',
            component: PollForm
        },
        {
            path: '/poll/edit/:id',
            name: 'poll.edit',
            component: PollForm
        },
        {
            path: '/poll/view/:id',
            name: 'poll.view',
            component: PollView
        }
    ]
}
